import React from "react";
import classNames from "classnames";

import s from "./footer.module.scss";

export default function Footer() {
  return <div className={classNames(s.footer, 'container')}>JetBrains Hackathon 2023</div>;
}
